import { UIHeading5, UIText3 } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as style from './style.css';

export interface INewbuildingPremiumBuilderStats {
  testId: string;
  title: string;
  value: string;
  link?: string;
  onClick?(): void;
}

export interface INewbuildingPremiumBuilderLayoutProps {
  logo: React.ReactElement;
  label?: React.ReactElement | null;
  stats: INewbuildingPremiumBuilderStats[];
}

export const NewbuildingPremiumBuilderLayout: React.FC<INewbuildingPremiumBuilderLayoutProps> = ({
  logo,
  label,
  stats,
}) => {
  return (
    <div className={style['container']}>
      <div className={style['background']} />
      {logo}
      {label && label}

      <div className={style['wrapper']}>
        {stats.map(({ testId, title, value, link, onClick }) => {
          return link ? (
            <a
              key={value}
              data-testid={testId}
              className={cn(style['title'], stats.length === 1 && style['full-width'])}
              href={link}
              target="blank"
              rel="noreferrer"
              onClick={onClick}
            >
              <UIText3 color="gray60_100">{title}</UIText3>
              <UIHeading5 color="black_100">{value}</UIHeading5>
            </a>
          ) : (
            <div
              key={value}
              data-testid={testId}
              className={cn(style['title'], stats.length === 1 && style['full-width'])}
            >
              <UIText3 color="gray60_100">{title}</UIText3>
              <UIHeading5 color="black_100">{value}</UIHeading5>
            </div>
          );
        })}
      </div>
    </div>
  );
};
